import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';

import Main from './components/Main';
import store from './store';
import {gatekeeper} from './store/users';

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'euprod') {
  console.log('environment: ', process.env.NODE_ENV);
}

const load = () => {
  ReactDOM.render(
    (
      <Provider store={store}>
        <Router><Main/></Router>
      </Provider>
    ),
    document.getElementById('root'),
  );
};

if (gatekeeper.currentSession) {
  load();
} else {
  gatekeeper.checkSession()
    .then((result) => {
      console.log('gatekeeper result:', result);
      load();
    })
    .catch((err) => {
      console.log('gatekeeper error: ', err);
      if (_.get(err, 'error') === 'login_required') {
        gatekeeper.authorize();
      } else {
        // strange error - load the page
        load();
      }
    });
}
